

import { RangeLabelModel } from './RangeLabelModel';
import { types } from 'mobx-state-tree';

export const RangeIntervalModel = types.model('RangeIntervalModel', {
  label: RangeLabelModel,
  minValue: types.number,
  maxValue: types.number,
});

